import { CouponItem, getCouponList } from '@/api/coupon-list';
import { i18n } from '../../i18n/index';
import dayjs from 'dayjs';

export enum USEABLE_FLAG {
  VALID = '1',
  INVALID = '2'
}

const PAGE_SIZE = 10;
const INIT_PAGE_CONFIG = {
  /** 页码 */
  offset: 0,
  /** 优惠券的可用状态 */
  useableFlag: '1',
  /** 单页查询数量 */
  limit: PAGE_SIZE,
};
let pageConfig = INIT_PAGE_CONFIG;
export const couponListPageConfigStore = {
  reset: (useableFlag) => {
    pageConfig = { ...INIT_PAGE_CONFIG, useableFlag };
  },
  set: (config) => {
    pageConfig = { ...pageConfig, ...config };
  },
  get: () => pageConfig,
};
export interface CouponItemExtend extends CouponItem {
  couponTagStatus: CouponTagStatus | undefined,
  couponTagText: string,
  displayExpireTime: string
}

export enum CouponTagStatus {
  /** 蓝色，优惠券尚未可用 */
  blue = 'blue',
  /** 橙色，推荐分类，预留 */
  orange = 'orange',
  /** 红色，即将到期 */
  red = 'red',
  /** 灰色，熔断特性分类，预留 */
  gray = 'gray'
}

export const getCurrentTime = () => {
  const serverTime = (window as any).__$$_serverTimeMills;
  return serverTime ? new Date(serverTime) : new Date();
};

/** 生效时间是否未到 */
export const isCouponNotStartValid = (coupon: CouponItem): boolean => new Date(coupon.validTime) > getCurrentTime();

const getCouponTagStatus = (coupon: CouponItem) => {
  // blue>grey>red>orange
  if (isCouponNotStartValid(coupon)) {
    return CouponTagStatus.blue;
  }
  if (coupon.isExpireNotified) {
    return CouponTagStatus.red;
  }
};


export const getNatureDateDiff = ({ currentDate, compareDate }): number => {
  const compareTime = new Date(new Date(compareDate).setHours(0, 0, 0, 0)).getTime();// 获取当天零点
  const currentTime = new Date(new Date(currentDate).setHours(0, 0, 0, 0)).getTime();
  const diffTime = compareTime - currentTime;
  return diffTime / 1000 / 60 / 60 / 24;
};

const getCouponTagText = (coupon: CouponItem): string => {
  const tagStatus = getCouponTagStatus(coupon);
  const natureDateDiff = getNatureDateDiff({ currentDate: getCurrentTime(), compareDate: coupon.validTime });
  const validTime =  dayjs(coupon.validTime || '').format('YYYY-MM-DD');
  switch (tagStatus) {
    case CouponTagStatus.red:
      return i18n('即将到期');
    case CouponTagStatus.blue:
      if (natureDateDiff > 2) {
        return i18n('${validTime}起可用', { validTime });
      } if (natureDateDiff === 2) {
        return i18n('${validTime}后天起可用', { validTime });
      } if (natureDateDiff === 1) {
        return i18n('明天起可用');
      } if (natureDateDiff === 0) {
        return i18n('今天稍后可用');
      }
    default:
      return '';
  }
};

// input: 2021/10/12 23:59:59; output: 2021.10.12
export const formatDisplayExpireTime = (coupon: CouponItem): string => (coupon.expireTime || '').replace(/\//g, '.').slice(0, 10);

export const formatCouponItem = (coupons: CouponItem[]): CouponItemExtend[] => coupons.map(item => ({
  ...item,
  couponTagText: getCouponTagText(item),
  couponTagStatus: getCouponTagStatus(item),
  displayExpireTime: formatDisplayExpireTime(item),
}));


export const getCouponListByPage = async (): Promise<{ coupons: CouponItemExtend[]; hasMore: boolean; }> => {
  const { offset, useableFlag, limit } = couponListPageConfigStore.get();
  const resCoupon = await getCouponList({ offset, useableFlag, limit });
  const hasMore = resCoupon.length === limit;
  couponListPageConfigStore.set({ offset: offset + 1 }); // 页数自增1
  return { coupons: formatCouponItem(resCoupon), hasMore };
};

export const isLongAmount = (discount = '') => discount.length >= 5 || (discount.length === 4 && discount.indexOf('.') === -1);
